import * as React from 'react';
import { useIntl } from 'react-intl';

import { MultipleLineTruncate } from '../../../../../../../components/LineTruncate';
import css from './BooksStaffDescription.module.scss';

interface DescriptionOwnProps {
  text: string;
}
type DescriptionProps = DescriptionOwnProps;
const BooksStaffDescription = (props: DescriptionProps) => {
  const [ellipsis, setEllipsis] = React.useState(true);
  const [clampedState, setClampedState] = React.useState(true);
  const intl = useIntl();

  return (
    <div className={css.BooksStaffDescription}>
      {ellipsis ? (
        <MultipleLineTruncate
          className={css.BooksStaffDescription__Body}
          maxLine={3}
          onReflow={({ clamped }) => setClampedState(!!clamped)}
          text={props.text}
        />
      ) : (
        <div className={css.BooksStaffDescription__Body}>{props.text}</div>
      )}
      {clampedState && (
        <button
          className={css.BooksStaffDescription__TruncateButton}
          onClick={(ev) => {
            ev.preventDefault();
            setEllipsis(!ellipsis);
          }}
        >
          {ellipsis
            ? intl.formatMessage({ id: 'books.booksMenu.truncateOpen' })
            : intl.formatMessage({ id: 'books.booksMenu.truncateClose' })}
        </button>
      )}
    </div>
  );
};

export default BooksStaffDescription;
